module.exports = __webpack_public_path__ + "static/media/header-tablet.f1c82001.jpg";